import React from 'react';
import { motion } from 'framer-motion';
import FloatingLabel from './FloatingLabel';
import { Brain, Moon, Smile, Activity, Heart, Sun, Coffee, Zap, Shield, Star, Flame, Battery, Leaf } from 'lucide-react';

interface BannerItemProps {
  text: string;
  icon: React.ReactNode;
}

// Mental and cognitive benefits
const topItems: BannerItemProps[] = [
  { text: "Mental Clarity", icon: <Brain size={16} className="lg:w-5 lg:h-5" /> },
  { text: "Focus Boost", icon: <Zap size={16} className="lg:w-5 lg:h-5" /> },
  { text: "Mood Support", icon: <Smile size={16} className="lg:w-5 lg:h-5" /> },
  { text: "Stress Relief", icon: <Sun size={16} className="lg:w-5 lg:h-5" /> },
  { text: "Memory Aid", icon: <Star size={16} className="lg:w-5 lg:h-5" /> },
  { text: "Cognitive Health", icon: <Shield size={16} className="lg:w-5 lg:h-5" /> },
];

// Physical and wellness benefits
const bottomItems: BannerItemProps[] = [
  { text: "Sleep Support", icon: <Moon size={16} className="lg:w-5 lg:h-5" /> },
  { text: "Energy Boost", icon: <Coffee size={16} className="lg:w-5 lg:h-5" /> },
  { text: "Heart Health", icon: <Heart size={16} className="lg:w-5 lg:h-5" /> },
  { text: "Vitality", icon: <Activity size={16} className="lg:w-5 lg:h-5" /> },
  { text: "Stamina", icon: <Flame size={16} className="lg:w-5 lg:h-5" /> },
  { text: "Natural Power", icon: <Leaf size={16} className="lg:w-5 lg:h-5" /> },
];

const MovingBanner = () => {
  return (
    <div className="fixed bottom-6 lg:bottom-0 left-0 right-0 min-h-[120px] lg:min-h-[160px] pb-2 lg:pb-4">
      <div className="relative h-full max-w-[1200px] mx-auto">
        {/* Gradient masks */}
        <div className="absolute left-0 top-0 bottom-0 w-16 lg:w-24 bg-gradient-to-r from-background to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-16 lg:w-24 bg-gradient-to-l from-background to-transparent z-10" />
        
        <div className="overflow-hidden h-full flex flex-col items-center">
          {/* Top row - moving left */}
          <div className="h-8 lg:h-16 relative w-full">
            <div className="flex absolute left-0 top-0 w-[200%] h-full">
              {[1, 2].map((set) => (
                <div key={set} className="flex min-w-max gap-6 lg:gap-12 pr-6 lg:pr-12 animate-scroll-left h-full items-center">
                  {topItems.map((item, index) => (
                    <FloatingLabel
                      key={`top-${set}-${index}`}
                      text={item.text}
                      icon={item.icon}
                      position="left"
                      className="shrink-0 min-w-max"
                    />
                  ))}
                </div>
              ))}
            </div>
          </div>

          {/* Bottom row - moving right */}
          <div className="h-12 lg:h-16 relative w-full">
            <div className="flex absolute left-0 top-0 w-[200%] h-full">
              {[1, 2].map((set) => (
                <div key={set} className="flex min-w-max gap-6 lg:gap-12 pr-6 lg:pr-12 animate-scroll-right h-full items-center">
                  {bottomItems.map((item, index) => (
                    <FloatingLabel
                      key={`bottom-${set}-${index}`}
                      text={item.text}
                      icon={item.icon}
                      position="right"
                      className="shrink-0 min-w-max"
                    />
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MovingBanner; 